import { DESTINATIONS } from 'constants/config/region'
import Places from 'constants/places'

const CONFIG_GEOGRAPHIC_LABEL_TO_PLACE_ID: Record<string, string> = {
  Adelaide: Places.Adelaide.id,
  Anywhere: Places.Anywhere.id,
  Australia: Places.Australia.id,
  Bali: Places.Bali.id,
  California: DESTINATIONS.california.destinationId,
  Europe: DESTINATIONS.europe.destinationId,
  Fiji: Places.Fiji.id,
  Hawaii: Places.Hawaii.id,
  'Hong Kong': Places.HongKong.id,
  Indonesia: Places.Indonesia.id,
  Italy: Places.Italy.id,
  Japan: Places.Japan.id,
  Maldives: Places.Maldives.id,
  'New Zealand': Places.NewZealand.id,
  Portugal: 'le_8d5e957f297893487bd98fa830fa6413',
  Singapore: Places.Singapore.id,
  'South Pacific': DESTINATIONS.south_pacific.destinationId,
  Spain: Places.Spain.id,
  Thailand: Places.Thailand.id,
  'United Kingdom': Places.UnitedKingdom.id,
  'United States': Places.UnitedStates.id,
  Vietnam: Places.Vietnam.id,
  Africa: DESTINATIONS.africa.destinationId,
  Amsterdam: 'le_8bf1211fd4b7b94528899de0a43b9fb3',
  Anguilla: 'le_1679091c5a880faf6fb5e6087eb1b2dc',
  'Antigua and Barbuda': DESTINATIONS.antigua.destinationId,
  Auckland: Places.Auckland.id,
  Austria: 'le_6512bd43d9caa6e02c990b0a82652dca',
  Bangkok: DESTINATIONS.bangkok.destinationId,
  Barcelona: 'le_3dc4876f3f08201c7c76cb71fa1da439',
  Berlin: 'le_65658fde58ab3c2b6e5132a39fae7cb9',
  Bermuda: 'le_98f13708210194c475687be6106a3b84',
  Botswana: 'le_b6d767d2f8ed5d21a44b0e5886680cb9',
  Brazil: 'le_37693cfc748049e45d87b8c7d8b9aacd',
  Brisbane: Places.Brisbane.id,
  Cairns: Places.Cairns.id,
  Cambodia: 'le_6ea9ab1baa0efb9e19094440c317e21b',
  Canada: Places.Canada.id,
  Canberra: Places.Canberra.id,
  'Central Coast': 'le_b26457e8774dcf3bf66024f7600ee686',
  'Chiang Mai': 'le_f964e87e2c42208253412904eec37214',
  'Chiang Rai': 'le_862f8a93dd2a5dffd8e708d49dbdb969',
  China: Places.China.id,
  Christchurch: Places.Christchurch.id,
  Colombia: 'le_a5771bce93e200c36f7cd9dfd0e5deaa',
  'Cook Islands': DESTINATIONS.cook_islands.destinationId,
  'Costa Rica': 'le_a1d0c6e83f027327d8461063f4ac58a6',
  Croatia: Places.Croatia.id,
  Czechia: 'le_d9d4f495e875a2e075a1a4a6e1b9770f',
  Darwin: Places.Darwin.id,
  'Dominican Republic': 'le_c0c7c76d30bd3dcaefc96f40275bdc0a',
  Dubai: Places.Dubai.id,
  Egypt: DESTINATIONS.egypt.destinationId,
  Florida: DESTINATIONS.florida.destinationId,
  France: Places.France.id,
  Germany: Places.Germany.id,
  'Gold Coast': Places.GoldCoast.id,
  Greece: Places.Greece.id,
  Hanoi: 'le_e7708a01a999a96c804a6b3c122d31c0',
  'Ho Chi Minh': 'le_747d3443e319a22747fbb873e8b2f9f2',
  Hobart: Places.Hobart.id,
  Hungary: 'le_35f4a8d465e6e1edc05f3d8ab658c551',
  Iceland: Places.Iceland.id,
  India: Places.India.id,
  Ireland: Places.Ireland.id,
  Israel: Places.Israel.id,
  Jamaica: Places.Jamaica.id,
  Jordan: DESTINATIONS.jordan.destinationId,
  'Khao Lak': Places.KhaoLak.id,
  'Koh Samui': Places.KohSamui.id,
  Krabi: 'le_b536d75d9b756802546437b33b09b5e8',
  'Kuala Lumpur': 'le_6a508a60aa3bf9510ea6acb021c94b48',
  Langkawi: 'le_6bfd7a723e671ca2c8bb5e22a875e4ad',
  Laos: 'le_26657d5ff9020d2abefe558796b99584',
  Launceston: 'le_019cf615e71dc6ec778f64fb0022f3d9',
  London: 'le_51174add1c52758f33d414ceaf3fe6ba',
  'Los Angeles': 'le_c8758b517083196f05ac29810b924aca',
  Macao: Places.Macau.id,
  Madrid: 'le_6832a7b24bc06775d02b7406880b93fc',
  Malaysia: Places.Malaysia.id,
  'Maldives Islands': Places.Maldives.id,
  Malta: 'le_698d51a19d8a121ce581499d7b701668',
  Mauritius: DESTINATIONS.mauritius.destinationId,
  Mediterranean: DESTINATIONS.mediterranean.destinationId,
  Melbourne: Places.Melbourne.id,
  Mexico: Places.Mexico.id,
  Milan: 'le_ffedf5be3a86e2ee281d54cdc97bc1cf',
  Montenegro: 'le_0cf05e5adbf5f3a64c72fb3d6a24758f',
  Morocco: DESTINATIONS.morocco.destinationId,
  Netherlands: Places.Netherlands.id,
  'New York': 'le_cc70903297fe1e25537ae50aea186306',
  Oman: 'le_e00da03b685a0dd18fb6a08af0923de0',
  Paris: 'le_7f7c351ee977c765aa8cd5c7020bc38f',
  Perth: Places.Perth.id,
  Peru: 'le_0a09c8844ba8f0936c20bd791130d6b6',
  Philippines: Places.Philippines.id,
  Phuket: Places.Phuket.id,
  Poland: 'le_a5e00132373a7031000fd987a3c9f87b',
  'Port Douglas': 'le_dc2afc2240bd3cd5067a740a2cb17399',
  'Port Stephens': 'le_5186b5eb83798a2a7a0bec02e7e95c5d',
  Qatar: Places.Qatar.id,
  Queenstown: Places.Queenstown.id,
  Queensland: Places.Queensland.id,
  Rome: 'le_09d37c08f7b129e96277388757530c72',
  Rotarua: 'le_732d6bb3074eefac3b2287d0bd8ef8fa',
  Rwanda: 'le_1d7f7abc18fcb43975065399b0d1e48e',
  'Saint Lucia': 'le_006f52e9102a8d3be2fe5614f42ba989',
  Samoa: DESTINATIONS.samoa.destinationId,
  'San Francisco': 'le_fb2606a5068901da92473666256e6e5b',
  'Saudi Arabia': Places.SaudiArabia.id,
  Seychelles: 'le_140f6969d5213fd0ece03148e62e461e',
  Shanghai: 'le_1160453108d3e537255e9f7b931f4e90',
  'South Africa': Places.SouthAfrica.id,
  'South America': DESTINATIONS.south_america.destinationId,
  'South Korea': Places.Korea.id,
  'Sri Lanka': Places.SriLanka.id,
  Sweden: 'le_f7e6c85504ce6e82442c770f7c8606f0',
  Switzerland: 'le_bf8229696f7a3bb4700cfddef19fa23f',
  Sydney: Places.Sydney.id,
  Tanzania: 'le_96da2f590cd7246bbde0051047b0d6f7',
  Taupo: 'le_f8f5161cf94df05793592f5fab95138b',
  'The Bahamas': 'le_c51ce410c124a10e0db5e4b97fc2af39',
  Tokyo: 'le_cdd0500dc0ef6682fa6ec6d2e6b577c4',
  Turkey: DESTINATIONS.turkey.destinationId,
  Ubud: Places.Ubud.id,
  UK: Places.UnitedKingdom.id,
  'United Arab Emirates': Places.UnitedArabEmirates.id,
  USA: Places.UnitedStates.id,
  Vanuatu: 'le_58a2fc6ed39fd083f55d4182bf88826d',
  Venice: 'le_6754e06e46dfa419d5afe3c9781cecad',
  Zimbabwe: 'le_3644a684f98ea8fe223c713b77189a77',
}

export function getConfigGeographicPlaceId(label: string): string | undefined {
  return CONFIG_GEOGRAPHIC_LABEL_TO_PLACE_ID[label]
}
